import HMOApi, {LETTERS} from "store/api/HMOApi";

const BASE_URL = "/letter";

export const ProgramApi = HMOApi.injectEndpoints({
    endpoints: (build) => ({
        fetchLettersForCareProvider: build.query({
            query: (careProviderId) => ({url: `${BASE_URL}/care-provider/${careProviderId}`}),
            method: "GET",
            providesTags: [LETTERS],
        }),
        getPatientsLetterData: build.mutation({
            query: ({patientIds, letterFileName}) => ({
                url: `${BASE_URL}/patient-data/${letterFileName}`,
                method: "POST",
                data: patientIds
            })
        })
    })
});

export const {
    useFetchLettersForCareProviderQuery,
    useGetPatientsLetterDataMutation,
} = ProgramApi;
